import { useSession } from '../../api/session';
import App from '../../App.jsx';
import { PortailClient } from './PortailClient.jsx';

/**
 * Ce que la session ouvre : l'application de l'entreprise, ou — pour le
 * client du magasin connecté avec son compte — son espace client, et rien
 * d'autre. Aucune donnée de l'entreprise n'est demandée pour lui.
 *
 * @returns {import('react').ReactElement} l'application ou l'espace client
 */
export function Racine() {
  const { session } = useSession();
  return session?.role === 'client' ? <PortailClient /> : <App />;
}
